import React, {FC, useContext} from 'react'
import styled from 'styled-components'
import { TokenWithData } from '../../../api/api-types'
import { Wei } from '../../../utils/types'
import { MultiDepositPreview } from '../deposit/MultiDepositPreview'
import { Pool } from '../../../logic/pools/Pool'
import { CheckCircle } from '../../catalog/icons/CheckCircle'
import {EmptyLine} from '../../catalog/EmptyLine'
import {Web3Context} from '../../../hooks/web3'

const DepositPostviewWrapper = styled.div`
  padding-top: 0px;
  display: flex;
  flex-direction: column;
`

export interface Props {
  userShareExit: Wei
  amounts: Map<TokenWithData, Wei>
  pool: Pool
  hash:string
}

export const WithdrawPostview: FC<Props> = ({
  userShareExit,
  amounts,
  pool,
  hash
}) => {
  const {
    web3,
    config: { getExplorerUrl },
  } = useContext(Web3Context)

  const txUrl = getExplorerUrl(hash)
  return (
    <DepositPostviewWrapper>
      <div className={'align-center text-center'}>
        <span className={'light'} style={{ paddingRight: '5px' }} data-cy={'confirmed'}>
          Confirmed
        </span>
        <CheckCircle />
      </div>
      <MultiDepositPreview
        amounts={amounts}
        pool={pool}
        expectedShare={userShareExit}
        isWithdraw={true}
      />
      <div className={'align-center text-center'}>
        <EmptyLine />
        <a href={txUrl} className={'link pt20 small-text'} target={'_blank'}>
          Transaction on explorer
        </a>
      </div>
    </DepositPostviewWrapper>
  )
}
